import React, { Component } from 'react';
import '../assets/custom.css';
import '../assets/teachers.css';
import './Content.css';

import { withRouter } from 'react-router-dom';

import HeaderComponent from '../Shared/Header';
import REST from '../Shared/REST';
import ico_plus_green from '../assets/images/ico_plus_green.png';
import ico_view from '../assets/images/ico_view.png';
import FooterComponent from "../Shared/Footer";
import DialogBox from "../Shared/DialogBox";
import DeleteDialogBox from "../Shared/DeleteDialogBox";
import Select from 'react-select';

const typeOptions = [
    { value: 'E', label: 'Expository' },
    { value: 'N', label: 'Narrative' }
];

const levelOptions = [
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
    { value: '6', label: '6' },
    { value: '7', label: '7' },
    { value: '8', label: '8' },
    { value: '9', label: '9' },
    { value: '10', label: '10' },
    { value: '11', label: '11' },
    { value: '12', label: '12' }
];

class KSContent extends Component {
    constructor(props) {
        super(props);
        this.state = { passages: [], passageToEdit: {}, addPassage: false, editPassage: false , showDeleted: false};
        this.handleAddPassage = this.handleAddPassage.bind(this);
        this.handleHideDeleted = this.handleHideDeleted.bind(this);
    }

    componentDidMount() {
        this.listPassages();
    }

    handleHideDeleted(event) {
        this.setState({ showDeleted: event.target.checked });
        this.listPassages();
    }

    async listPassages() {
        await REST.listKidSpeakPassages().then((response) => {
            if (response.success) {
                this.setPassages(response.body);
            }
            else {
                console.log('Error', response.msg);
            }
        }, (error) => {
            console.log('Error', error.msg);
        });
    }

    setPassages = (object) => {
        object.sort((a,b) =>
            ((a.level > b.level)||((a.level === b.level)&&(a.id > b.id))) ? 1 :
                (((a.level < b.level)||((a.level === b.level)&&(a.id < b.id))) ? -1 : 0)
        );
        this.setState({ passages: object });
    }

    handleAddPassage(event) {
        this.setState({ addPassage: !this.state.addPassage, editPassage: false });
    }

    handleCancel = () => {
        this.setState({ addPassage: false, editPassage: false });
    }

     handlePassageItemClick = (object) => {
        this.setState({ addPassage: false, editPassage: true, passageToEdit: object });
    }

    handleLogout = () => {
        REST.logout().then((response) => {
            localStorage.removeItem('token');
            this.props.history.push("/login");
        }, (error) => {
            this.props.history.push("/login");
        });
    }

    passageAdded = () => {
        this.listPassages();
    }

    passageUpdated = async (passageId) => {
        await this.listPassages();
        let newPassage = this.state.passages.filter(
            passage => passage.id == passageId
        )[0];

        this.setState({ addPassage: false, editPassage: true, passageToEdit: newPassage });
    }

    render() {
        return (
            <div>
                <HeaderComponent contentManagement={true}  logout={this.handleLogout} />
                <div className="section bgGrey">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <div className={"row"}>
                                    <div className={"col-md-5"}>
                                        <h1 className="fl">KidSpeak Passages</h1>
                                    </div>
                                    <div className={"col-md-6"}>
                                        <div className={"row"}>
                                            <div className={"col-md-3"}>
                                                <input type="checkbox" onChange={this.handleHideDeleted} id="checkHideDeleted" className="form-control" />
                                            </div>
                                            <div className={"col-md-9"} style={{marginTop: 10, marginLeft: -40}}>
                                                Show Decommissioned
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"col-md-1"}>
                                        <a className="fr">
                                            <img src={ico_plus_green} onClick={this.handleAddPassage} alt="Plus Icon" border="0" className="ico-xs ico-add" />
                                        </a>
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12 solidBorder noPadding scrollable" style={{maxHeight: 500}}>
                                    <PassagesListComponent passages={this.state.passages} handleItemClick={this.handlePassageItemClick} showDeleted={this.state.showDeleted}/>
                                </div>
                                <div>In Total: {this.state.passages.length}</div>
                            </div>
                            {this.state.addPassage ?
                                <div className="col-md-6 container navbar-container">
                                    <AddPassageComponent handlePassageAdded={this.passageAdded} handleCancel={this.handleCancel} />
                                </div> : null}
                            {this.state.editPassage ?
                                <div className="col-md-6 container navbar-container">
                                    <UpdatePassageComponent handlePassageUpdated={this.passageUpdated} passages={this.state.passages} passage={this.state.passageToEdit} handleCancel={this.handleCancel} />
                                </div> : null}
                        </div>
                    </div>
                </div>
                <FooterComponent/>
            </div>
        );
    }
}

class AddPassageComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            level: '',
            passageType: '',
            title: '',
            storyStarter:''
        };
        this.handleLevelSelect = this.handleLevelSelect.bind(this);
        this.handleTypeSelect = this.handleTypeSelect.bind(this);
        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handleContentChange = this.handleContentChange.bind(this);

        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handleLevelSelect(event) {
        this.setState({ level: event.value });
    }

    handleTypeSelect(event) {
        this.setState({ passageType: event.value });
    }

    handleTitleChange(event) {
        this.setState({ title: event.target.value });
        event.preventDefault();
    }

    handleContentChange(event) {
        this.setState({ storyStarter: event.target.value });
        event.preventDefault();
    }

    handleCancel(event) {
        this.props.handleCancel();
    }

    handleSave(event) {
        REST.addKidSpeakPassage(this.state).then((response) => {
            if (response.success) {
                this.setState({
                    modalDialog: true,
                    responseContent: 'Passage Successfully Added!'
                });
                setTimeout(()=>{this.setState({modalDialog:false}); this.props.handleCancel();},3500);
                this.props.handlePassageAdded();
                this.myFormRef.reset();
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg
                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            this.setState({
                modalDialog: true,
                responseContent:error.msg
            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
    }

    render() {
        return (
            <div className="col-lg-12 solidBorder hasfitWidth" >
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <form id="formAddPassage" ref={(el) => this.myFormRef = el}>
                    <label htmlFor="selectLevel">Level</label>
                    <Select onChange={this.handleLevelSelect} id="selectLevel" name="classes"   options={levelOptions} isSearchable={false} />
                    <label htmlFor="selectType">Type</label>
                    <Select onChange={this.handleTypeSelect} id="selectType" name="classes"   options={typeOptions} isSearchable={false} />
                    <label htmlFor="inputTitle">Title</label>
                    <input type="text" onChange={this.handleTitleChange} id="inputTitle" className="form-control fullWidth" placeholder="Title" size="30" maxLength={50} required autoFocus />
                    <label htmlFor="inputContent">Content</label>
                    < textarea onChange={this.handleContentChange} placeholder="Input KidSpeak passage content" className="form-control w100" rows={8}></textarea>
                </form>
                <div className="nav navbar fr">
                    <a onClick={this.handleCancel} className="handBtn">
                        <span>Cancel</span>
                    </a>
                    <a onClick={this.handleSave} className="handBtn">
                        <span>Add Passage</span>
                    </a>
                </div>
            </div>
        );
    }
}

class UpdatePassageComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            passageIdOptions: this.getVersionOptions(this.props.passage.uId),
            passage: {
                id: this.props.passage.id,
                level: this.props.passage.level,
                passageType: this.props.passage.passageType,
                title: this.props.passage.title,
                storyStarter: this.props.passage.storyStarter,
                uId: this.props.passage.uId,
                deletedAt: this.props.passage.deletedAt,
            },
            modalDialog:false,
            modalDialogDelete:false
        };
        this.handleVersionSelect = this.handleVersionSelect.bind(this);
        this.getVersionOptions = this.getVersionOptions.bind(this);
        this.handleLevelSelect = this.handleLevelSelect.bind(this);
        this.handleTypeSelect = this.handleTypeSelect.bind(this);
        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handleContentChange = this.handleContentChange.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleActivate = this.handleActivate.bind(this);
        this.deletePassage = this.deletePassage.bind(this);
    }

    componentDidUpdate(oldProps){
        const newProps = this.props;
        if(oldProps.passage.id !== newProps.passage.id){
            this.setState({
                passageIdOptions: this.getVersionOptions(this.props.passage.uId),
                passage: {
                    id: this.props.passage.id,
                    level: this.props.passage.level,
                    passageType: this.props.passage.passageType,
                    title: this.props.passage.title,
                    storyStarter: this.props.passage.storyStarter,
                    uId: this.props.passage.uId,
                    deletedAt: this.props.passage.deletedAt,
                },
                modalDialog:false,
                modalDialogDelete:false
            });
        }
    }

    handleVersionSelect(event){
        let selectedPassage = this.props.passages.filter(
            passage => passage.id == event.value
        )[0];
        this.setState({
            passage: {
                id: selectedPassage.id,
                level: selectedPassage.level,
                passageType: selectedPassage.passageType,
                title: selectedPassage.title,
                storyStarter: selectedPassage.storyStarter,
                uId: selectedPassage.uId,
                deletedAt: selectedPassage.deletedAt,
            }
        });
    }

    getVersionOptions(uId) {
        let versionOptions = [];
        this.props.passages.forEach(function (passage) {
            if (passage.uId === uId) {
                let version = {
                    value: passage.id,
                    label: 'passageId: ' + passage.id,
                    deletedAt: passage.deletedAt
                };
                if (passage.deletedAt) {
                    version.label += ' (Decommissioned | ' + passage.deletedAt.substring(0,19).replace('T', ' ') + ')';
                } else {
                    version.label += ' (Active)';
                }
                versionOptions.push(version);
            }
        });

        let sortedVersionOptions = versionOptions.sort(function (a,b) {
            if (!a.deletedAt) return -1;
            if (!b.deletedAt) return 1;
            return (a.deletedAt > b.deletedAt) ? -1 : ((a.deletedAt < b.deletedAt) ? 1 : 0);
        });

        return sortedVersionOptions;
    }

    deletePassage = (confirm) =>{
        if(confirm) {
            if(this.state.passage.deletedAt) {
                this.handleActivate();
            }else{
                this.handleDelete();
            }
        }
        this.setState({
            modalDialogDelete:false,
        });
    }

    handleLevelSelect(event) {
        this.setState({ passage:{
            ...this.state.passage,
            level: event.value
        }});
    }

    handleTypeSelect(event) {
        this.setState({
            passage:{
                ...this.state.passage,
                passageType: event.value
            }});
    }

    handleTitleChange(event) {
        this.setState({
            passage:{
                ...this.state.passage,
                title: event.target.value
            }});
        event.preventDefault();
    }

    handleContentChange(event) {
        this.setState({
            passage:{
                ...this.state.passage,
                storyStarter: event.target.value
            }});
        event.preventDefault();
    }

    handleCancel(event) {
        this.props.handleCancel();
        event.preventDefault();
    }

    handleSave(event) {
        REST.updateKidSpeakPassage(this.state.passage).then((response) => {
            if (response.success) {
                this.setState({
                    modalDialog: true,
                    responseContent:'Passage Data Successfully Updated!'
                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
                this.props.handlePassageUpdated(response.body.id);
            }
            else {
                alert(response.msg);
            }
        }, (error) => {
            alert(error.msg);
        });
        event.preventDefault();
    }

    handleDelete(event) {
        REST.deleteKidSpeakPassage(this.state.passage.id).then((response) => {
            if (response.success) {
                this.setState({
                    modalDialog: true,
                    responseContent:'Passage Successfully Deleted!'
                });
                setTimeout(()=>{this.setState({modalDialog:false}); this.props.handleCancel();},3500);
                this.props.handlePassageUpdated();
            }
            else {
                alert(response.msg);
            }
        }, (error) => {
            alert(error.msg);
        });
    }

    handleActivate(event) {
        REST.activateKidSpeakPassage(this.state.passage.id).then((response) => {
            if (response.success) {
                this.setState({
                    modalDialog: true,
                    responseContent:'Passage Successfully Activated!'
                });
                setTimeout(()=>{this.setState({modalDialog:false}); this.props.handleCancel();},3500);
                this.props.handlePassageUpdated();
            }
            else {
                alert(response.msg);
            }
        }, (error) => {
            alert(error.msg);
        });
    }

    render() {
        return (
            <div className="col-lg-12 solidBorder hasfitWidth">
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <DeleteDialogBox
                    confirmDelete={this.deletePassage}
                    modalOpen={this.state.modalDialogDelete}
                    sectionContent={this.state.responseContent}
                    closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <form>
                    <label htmlFor="inputPassageName">Versions (UID: {this.state.passage.uId})</label>
                    <Select onChange={this.handleVersionSelect} id="classes" name="classes"   options={this.state.passageIdOptions} value={this.state.passageIdOptions.filter(option => option.value == this.state.passage.id)} isSearchable={false} />
                    <label htmlFor="selectLevel">Level</label>
                    <Select onChange={this.handleLevelSelect} id="selectLevel" name="classes"  value={levelOptions.filter(option => option.value == this.state.passage.level)} options={levelOptions} isSearchable={false} isDisabled={this.state.passage.deletedAt?true:false}/>
                    <label htmlFor="selectType">Type</label>
                    <Select onChange={this.handleTypeSelect} id="selectType" name="classes" value={typeOptions.filter(option => option.value == this.state.passage.passageType)}  options={typeOptions} isSearchable={false} isDisabled={this.state.passage.deletedAt?true:false}/>
                    <label htmlFor="inputTitle">Title</label>
                    <input type="text" onChange={this.handleTitleChange} id="inputTitle" value={this.state.passage.title} className="form-control fullWidth" placeholder="Title" size="30" maxLength={50} required autoFocus disabled={this.state.passage.deletedAt?true:false}/>
                    <label htmlFor="inputContent">Content</label>
                    < textarea onChange={this.handleContentChange} value={this.state.passage.storyStarter} placeholder="Input KidSpeak passage content" className="form-control w100" rows={8} disabled={this.state.passage.deletedAt?true:false}></textarea>
                </form>
                <div className="nav navbar fl">
                    {this.state.passage.deletedAt?
                        <a onClick={(event) => {
                            this.setState({
                                modalDialogDelete: true,
                                responseContent: 'ARE YOU SURE YOU WANT TO ACTIVATE THIS PASSAGE?'
                            });
                            event.stopPropagation();
                        }} className="handBtn">
                            <span>Activate</span>
                        </a>:
                        <a onClick={(event) => {
                            this.setState({
                                modalDialogDelete: true,
                                responseContent: 'ARE YOU SURE YOU WANT TO DELETE THIS PASSAGE?'
                            });
                            event.stopPropagation();
                        }} className="handBtn">
                            <span>Decommission</span>
                        </a>
                    }
                </div>
                <div className="nav navbar fr">
                    <a onClick={this.handleCancel} className="handBtn">
                        <span>Cancel</span>
                    </a>
                    {this.state.passage.deletedAt? null:
                    <a onClick={this.handleSave} className="handBtn">
                        <span>Update</span>
                    </a>
                    }
                </div>
            </div>
        );
    }
}

class PassagesListComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: this.props.passages
        }
        this.sortPassagesById = this.sortPassagesById.bind(this);
        this.sortPassagesByLevel = this.sortPassagesByLevel.bind(this);
    }

    componentDidUpdate(oldProps) {
        const newProps = this.props;
        if(oldProps.passages !== newProps.passages) {
            this.setState({
                items: this.props.passages
            });
        }
    }

    sortPassagesById(){
        this.setState ({
            items: this.state.items.sort((a,b) =>
                ((a.id > b.id) ? 1 : ((a.id < b.id) ? -1 : 0))
            )
        });
    }

    sortPassagesByLevel(){
        this.setState ({
            items: this.state.items.sort((a,b) =>
                ((a.level > b.level) ? 1 : ((a.level < b.level) ? -1 : 0))
            )
        });
    }

    handleItemClick = (object) => {
        this.props.handleItemClick(object);
    }

    render() {
        let passages = this.state.items.map((item) => {
            if (!(item.deletedAt && !this.props.showDeleted)) {
                return <PassagesListItemComponent key={item.id} item={item} handleClick={this.handleItemClick} />
            }
            else return null;
        });
        return (
            <table cellPadding="0" cellSpacing="0" border="0" width="100%">
                <thead>
                    <th><a onClick={this.sortPassagesByLevel}>Level</a></th>
                    <th><a onClick={this.sortPassagesById}>ID</a></th>
                    <th>Title</th>
                    <th>Status</th>
                </thead>
                <tbody>
                    {passages}
                </tbody>
            </table>
        );
    }
}

class PassagesListItemComponent extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        this.props.handleClick(this.props.item);
        event.preventDefault();
    }

    render() {
        return (
            <tr className="clickable-row" onClick={this.handleClick}>
                <td>{this.props.item.level}</td>
                <td>{this.props.item.id}</td>
                <td>{this.props.item.title}</td>
                <td className="fitWidth">
                    <a>
                        {this.props.item.deletedAt?null:
                            <img src={ico_view} alt="View Icon" border="0" className="ico-xs" />
                        }
                    </a>
                </td>
            </tr>
        );
    }
}

export default withRouter(KSContent);